var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{ref:"autoLink",staticStyle:{"display":"none"},attrs:{"href":_vm.url,"rel":"noopener noreferrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }